import React, {useEffect, useState} from "react";
import { Fieldset } from 'primereact/fieldset';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext'; 
import { classNames } from 'primereact/utils';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import { Survey } from 'survey-react-ui';
import {Dropdown} from "primereact/dropdown";
import '../../../styles/linkSurvey.scss'
import {useFormik} from "formik";


export const InfoSurvey = (props) => {
    const { t, i18n } = useTranslation();
    const { surveyInfo ,  survey, isPublic, setComponentChild, setForm } = props;
    const [selected, setSelected] = useState({ name: t('LANGUAGE.EN'), code: 'en' });
    const [isLanguage, setLanguage] = useState(false);

    const lg = [
        { name: t('LANGUAGE.EN'), code: 'en' },
        { name: t('LANGUAGE.ES'), code: 'es' }
    ];

    useEffect(() => {
        const jsonData = JSON.parse(surveyInfo.content);
        setLanguage(typeof jsonData.pages[0].elements[0].title === "object")
    }, []);

    const structureModel = {
        initialValues: {
            fisrtName:  '' ,
            surName:  '',
            email:  '',
            role: t('RESPONDENT.SURVEY.PUBLIC.FORM.RESPONDENT'),
            termAndConditions: false
        },
        validate: (data) => {
            const errors = {};
            const textFirstName = t('RESPONDENT.SURVEY.PUBLIC.FORM.VALIDATIONS.FIRS_NAME');
            const textLastName = t('RESPONDENT.SURVEY.PUBLIC.FORM.VALIDATIONS.LAST_NAME');
            const textEmail = t('RESPONDENT.SURVEY.PUBLIC.FORM.VALIDATIONS.EMAIL');
            const textConditions = t('RESPONDENT.SURVEY.PUBLIC.FORM.VALIDATIONS.CONDITIONS');

            if (!data.fisrtName || data.fisrtName === '' ) {
                errors.fisrtName = textFirstName;
            }

            if (!data.surName || data.surName === '') {
                errors.surName = textLastName;
            }

            if (!data.email || data.email === '') {
                errors.email = textEmail;
            }
            if (!data.termAndConditions) {
                errors.termAndConditions = textConditions;
            }
            return errors;
        }
    }

    const formik = useFormik(structureModel);

    useEffect(() => {
        if (setForm) {
            setForm(formik)
        }
    }, [formik.errors, formik.values])

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;

    const onLanguageChange = (e) => {
        i18n.changeLanguage(e.value.code === 'es' ? 'es-co' : 'en-US').finally(() => {
            lg.forEach(x => {
                x.name =  t('LANGUAGE.' + (x.code).toUpperCase())
            });
            setComponentChild(e.value.code)
            setSelected(e.value);
        });


    }
    return (
        <>
            <br></br>
            <Fieldset legend={t('RESPONDENT.SURVEY.LEGEND')} toggleable>
                <div className="grid">
                    <div className="container-info-survey">
                        <div>
                            <b>{t('RESPONDENT.SURVEY.CLIENT')}</b>
                            <p>{surveyInfo?.client.companyName}</p>
                        </div>
                        <div>
                            <b>{t('RESPONDENT.SURVEY.MAIL_CLIENT')}</b>
                            <p>{surveyInfo?.client.email} </p>
                        </div>
                        {
                            isPublic && isLanguage ?
                                <div>
                                    <Dropdown className="text-xl" value={selected} options={lg}
                                              onChange={onLanguageChange} optionLabel="name"
                                              placeholder={t('PLACEHOLDERS.SELECT_A_LANGUAGE')}/>
                                </div> : <></>
                        }
                    {
                        setForm ?
                                <FormSendSurvey formik={formik} isFormFieldValid={isFormFieldValid}  getFormErrorMessage={getFormErrorMessage}  />
                            : <></>
                    }
                    </div>
                </div>
            </Fieldset>
            <br></br>
            <Survey model={survey} />
        <div id="surveyIdResponse"></div>
        </>
    );
}

export const FormSendSurvey = ({formik , isFormFieldValid ,  getFormErrorMessage }) => {

    const { t } = useTranslation();
    return (
        <div className="grid">
            <form  className="formgroup-inline">
                <div className="field">
                <span className="p-float-label">
                    <InputText id="fisrtName" name="fisrtName" value={formik.values.fisrtName} onChange={formik.handleChange} autoFocus className={classNames({ 'p-invalid': isFormFieldValid('fisrtName') })}
                    />
                    <label htmlFor="fisrtName" className={classNames({ 'p-error': isFormFieldValid('fisrtName') })}>{t('RESPONDENT.SURVEY.FORM_SEND.FIRST_NAME')}</label>
                </span>
                    {getFormErrorMessage('fisrtName')}
                </div>
                <div className="field">
                <span className="p-float-label">
                    <InputText id="surName" name="surName" value={formik.values.surName} onChange={formik.handleChange}  className={classNames({ 'p-invalid': isFormFieldValid('surName') })}
                    />
                    <label htmlFor="surName" className={classNames({ 'p-error': isFormFieldValid('surName') })}>{t('RESPONDENT.SURVEY.FORM_SEND.LAST_NAME')}</label>
                </span>
                    {getFormErrorMessage('surName')}
                </div>
                <div className="field">
                <span className="p-float-label p-input-icon-right">
                    <InputText id="email" name="email" value={formik.values.email} onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('email') })}
                    />
                    <label htmlFor="email" className={classNames({ 'p-error': isFormFieldValid('email') })}>{t('RESPONDENT.SURVEY.FORM_SEND.EMAIL')}</label>
                </span>
                    {getFormErrorMessage('email')}
                </div>
                <div className="field-checkbox">
                    <Checkbox id="termAndConditions" inputId="termAndConditions" name="termAndConditions" value={formik.values.termAndConditions} checked={formik.values.termAndConditions} onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('termAndConditions') })}  />
                    <a href="/TerminosYCondiciones/RESPONDENT" className='termAndConditions_a' target="_blank"><label  style={{cursor: 'pointer'}} htmlFor="termAndConditions" className={classNames({ 'p-error': isFormFieldValid('termAndConditions') })}>{t('RESPONDENT.SURVEY.FORM_SEND.CONDITIONS')}</label></a>
                </div>
            </form>
        </div>
    )
}


export const DialogSurvey = ({ showFrmOtp , onCloseDialog , validCode , SetValidCode }) => {
    return (
        <Dialog  visible={showFrmOtp} style={{ heigth: '50vw' }}  onHide={() => onCloseDialog()} >
            <div>
                <span>A verification code will be sent to your email account.</span>
                <br></br>
                <span>Enter the code sent to confirm the email.</span>
            </div>
            <div className="grid">
                <form  className="formgroup-inline">
                    <div className="field">
                            <span className="p-float-label">
                                <InputText id="validCode" name="validCode" value={validCode} onChange={SetValidCode} />
                                <label htmlFor="validCode" >First Name*</label>
                            </span>
                    </div>
                </form>
            </div>
        </Dialog>
    )
}
